export const adminPanelMixin = {
  data() {
    return {
      buildPanelContent: (component, data = null, size = '') => {
        let title;
        let showExerciseFilters = null;

        switch (component) {
          case 'CircuitForm':
            title = `Add Circuit`;
            break;
          case 'ClientForm':
            title = `${data ? 'Edit' : 'Create New'} Client`;
            break;
          case 'EquipmentForm':
            title = `${data ? 'Edit' : 'Create New'} Equipment`;
            break;
          case 'ExerciseList':
            title = data && data.panelTitle ? data.panelTitle : 'Add Exercise';
            showExerciseFilters = true;
            break;
          case 'WorkoutList':
            title =
              data && data.panelTitle ? data.panelTitle : 'Alternate Workout';
            break;
          case 'ProgramNote':
            title = data.title;
            break;
          case 'SplitPane':
            title = 'Alternate Workout';
            break;
          case 'SplitPaneFull':
            title = data && data.panelTitle ? data.panelTitle : '';
            break;
          case 'GroceryList':
            title = 'Grocery List';
            break;
          case 'ExerciseDetail':
            title =
              data && data.panelTitle ? data.panelTitle : 'Create New Exercise';
            break;
          case 'FitnessForm':
            title = `${data ? 'Edit' : 'Create New'} Fitness Type`;
            break;
          case 'ExerciseStepForm':
            title = `${
              data && data.step && data.step.order ? 'Edit' : 'Create New'
            } Step`;
            break;
          case 'RecipeIngredientForm':
            console.log(data);
            title = `${
              data && data.step && data.step.sortOrder ? 'Edit' : 'Add New'
            } Ingredient`;
            break;
          case 'RecipePreview':
            title = 'Recipe Detail';
            break;
          case 'RecipeForm':
            title =
              data && data.panelTitle ? data.panelTitle : 'Create New Recipe';
            break;
          case 'RecipeStepForm':
            title = `${
              data && data.instruction && data.instruction.step
                ? 'Edit'
                : 'Add New'
            } ${data.panelTitle}`;
            break;
          case 'TrainerForm':
            title = data && data.panelTitle ? data.panelTitle : 'Add Trainer';
            break;
          case 'WorkoutDetail':
            title =
              data && data.panelTitle ? data.panelTitle : 'Create Workout';
            break;
          case 'WorkoutPreview':
            title = `Workout Preview`;
            break;
          case 'MealPlanForm':
            title =
              data && data.panelTitle ? data.panelTitle : 'Create New Plan';
            break;
          case 'ProductForm':
            title = `New Product`;
            break;
          case 'ProductDetail':
            title = `Product Detail`;
            break;
          case 'ProductAccountDetails':
            title = `Add to ${this.$store.getters['organization/organizationTitle']} PAY`;
            break;
          case 'CouponForm':
            title = `Create Coupon`;
            break;
          case 'ProspectContactForm':
            title =
              data && data.panelTitle ? data.panelTitle : 'Compose Message';
            break;
          case 'ProspectMessageComposer':
            title =
              data && data.panelTitle ? data.panelTitle : 'Compose Message';
            break;
          default:
            console.error(
              `Error: Expected string with 'component name', got ${component}. Make sure ${component} is in the panel content list.`
            );
            break;
        }

        return {
          title: title,
          component: component,
          size: size,
          showExerciseFilters: showExerciseFilters,
          data: data,
        };
      },
    };
  },
  methods: {
    getPanelContent(component, data = null, size = '') {
      return this.buildPanelContent(component, data, size);
    },
  },
};
